/* unplugin-vue-components disabled */import { render } from "./TerminalsStatus.vue?vue&type=template&id=319ee7f7&ts=true"
import script from "./TerminalsStatus.vue?vue&type=script&lang=ts"
export * from "./TerminalsStatus.vue?vue&type=script&lang=ts"

import "./TerminalsStatus.vue?vue&type=style&index=0&id=319ee7f7&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__